import { unicodeCaseFold } from "./unicodeCaseFold";

// Byte-exact port of _VARIABLE_TOKEN in
// packages/domain/src/marker/domain/variable_pattern.py. The domain extractor
// excludes values below an `audio_ref` key; the Instruction, Goal, and Tool
// mocks strings scanned by the editor are not `audio_ref` fields.
const VARIABLE_TOKEN = /\{([A-Za-z0-9_][A-Za-z0-9_-]*)\}/g;

/** UUID-shaped tokens are identities, never key aliases (domain UUID parsing). */
export function isVariableIdToken(token: string): boolean {
  return /^[0-9a-f]{32}$/i.test(token.replaceAll("-", ""));
}

export function scanVariableTokens(...values: string[]): string[] {
  const tokens = new Map<string, string>();
  for (const value of values) {
    for (const match of value.matchAll(VARIABLE_TOKEN)) {
      const token = match[1];
      if (token !== undefined && !tokens.has(unicodeCaseFold(token))) {
        tokens.set(unicodeCaseFold(token), token);
      }
    }
  }
  return [...tokens.values()];
}
